import React, { useState, useRef, useEffect } from 'react';
import { Box, Typography, List, Skeleton, Avatar } from '@mui/material';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { useSelector } from 'react-redux';
import { getSigmaReports, updateKeyInMasterClass } from '../../app/util';
import moment from 'moment';

const otbIcon = (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="#fff" viewBox="0 0 256 256"><path d="M232,48H168a32,32,0,0,0-32,32v87.73a8.17,8.17,0,0,1-7.47,8.25,8,8,0,0,1-8.53-8V80A32,32,0,0,0,88,48H24a8,8,0,0,0-8,8V200a8,8,0,0,0,8,8H96a24,24,0,0,1,24,23.94,7.9,7.9,0,0,0,5.12,7.55A8,8,0,0,0,136,232a24,24,0,0,1,24-24h72a8,8,0,0,0,8-8V56A8,8,0,0,0,232,48ZM208,168H168.27a8.17,8.17,0,0,1-8.25-7.47,8,8,0,0,1,8-8.53h39.73a8.17,8.17,0,0,1,8.25,7.47A8,8,0,0,1,208,168Zm0-32H168.27a8.17,8.17,0,0,1-8.25-7.47,8,8,0,0,1,8-8.53h39.73a8.17,8.17,0,0,1,8.25,7.47A8,8,0,0,1,208,136Zm0-32H168.27A8.17,8.17,0,0,1,160,96.53,8,8,0,0,1,168,88h39.73A8.17,8.17,0,0,1,216,95.47,8,8,0,0,1,208,104Z"></path></svg>
)

const reportIcons = {
    otb_ea: (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="#fff" viewBox="0 0 256 256"><path d="M232,48H168a32,32,0,0,0-32,32v87.73a8.17,8.17,0,0,1-7.47,8.25,8,8,0,0,1-8.53-8V80A32,32,0,0,0,88,48H24a8,8,0,0,0-8,8V200a8,8,0,0,0,8,8H96a24,24,0,0,1,24,23.94,7.9,7.9,0,0,0,5.12,7.55A8,8,0,0,0,136,232a24,24,0,0,1,24-24h72a8,8,0,0,0,8-8V56A8,8,0,0,0,232,48ZM208,168H168.27a8.17,8.17,0,0,1-8.25-7.47,8,8,0,0,1,8-8.53h39.73a8.17,8.17,0,0,1,8.25,7.47A8,8,0,0,1,208,168Zm0-32H168.27a8.17,8.17,0,0,1-8.25-7.47,8,8,0,0,1,8-8.53h39.73a8.17,8.17,0,0,1,8.25,7.47A8,8,0,0,1,208,136Zm0-32H168.27A8.17,8.17,0,0,1,160,96.53,8,8,0,0,1,168,88h39.73A8.17,8.17,0,0,1,216,95.47,8,8,0,0,1,208,104Z"></path></svg>
    ),
    pickup_ea: (
        <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 13.642V1.26599M3.331 13.642V5.137M5.669 13.642V7.21599M8 13.642V3.296M10.331 13.642V7.88102M12.669 13.642V3.296M15 13.642V1" stroke="white" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
    ),
    flight_ea: (
        // <svg width="30" height="22" viewBox="0 0 30 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        //     <path d="M1.34766 20.925H28.5777" stroke="white" stroke-linecap="round" stroke-linejoin="round" />
        //     <path d="M29.0075 4.065C28.6675 2.975 25.8375 1.885 24.6175 1.815C23.6475 1.695 22.6575 1.835 21.7875 2.235L18.3475 3.505L12.3175 0.045C12.2175 -0.015 12.0975 -0.015 11.9875 0.045L9.8575 1.065C9.7475 1.115 9.6775 1.225 9.6575 1.345C9.6475 1.465 9.6975 1.585 9.7875 1.655L14.0475 5.045L6.5175 7.705L3.0975 5.395C3.0075 5.335 2.8975 5.325 2.7875 5.355L1.7275 5.745C1.5775 5.795 1.4375 5.885 1.3275 6.005C1.2075 6.115 1.1175 6.255 1.0675 6.415C1.0075 6.565 0.9875 6.725 1.0075 6.895C1.0175 7.055 1.0675 7.215 1.1575 7.355L2.1675 9.025C2.8275 10.135 3.7975 11.045 4.9575 11.625C5.6375 11.965 6.3675 12.155 7.1175 12.205C7.2375 12.215 7.3575 12.215 7.4775 12.215C8.1075 12.215 8.7375 12.115 9.3275 11.905L14.7275 10.025L14.9075 7.705C14.9175 7.515 15.0775 7.375 15.2775 7.385C15.4675 7.395 15.6175 7.565 15.5975 7.755L15.1157 14.0189C15.0983 14.2441 15.3268 14.407 15.5341 14.3172L16.5775 13.865C16.7275 13.805 16.8375 13.675 16.8775 13.515L18.1275 8.855L18.9375 8.555L21.0475 7.825L28.3575 5.275C28.6075 5.205 28.8075 5.035 28.9375 4.815C29.0575 4.595 29.0875 4.335 29.0175 4.075L29.0075 4.065Z" fill="white" />
        // </svg>
        <svg width="29" height="15" viewBox="0 0 29 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M28.0075 4.065C27.6675 2.975 24.8375 1.885 23.6175 1.815C22.6475 1.695 21.6575 1.835 20.7875 2.235L17.3475 3.505L11.3175 0.045C11.2175 -0.015 11.0975 -0.015 10.9875 0.045L8.8575 1.065C8.7475 1.115 8.6775 1.225 8.6575 1.345C8.6475 1.465 8.6975 1.585 8.7875 1.655L13.0475 5.045L5.5175 7.705L2.0975 5.395C2.0075 5.335 1.8975 5.325 1.7875 5.355L0.7275 5.745C0.5775 5.795 0.4375 5.885 0.3275 6.005C0.2075 6.115 0.1175 6.255 0.0675 6.415C0.00749995 6.565 -0.0125 6.725 0.00750001 6.895C0.0175 7.055 0.0675 7.215 0.1575 7.355L1.1675 9.025C1.8275 10.135 2.7975 11.045 3.9575 11.625C4.6375 11.965 5.3675 12.155 6.1175 12.205C6.2375 12.215 6.3575 12.215 6.4775 12.215C7.1075 12.215 7.7375 12.115 8.3275 11.905L13.7275 10.025L13.9075 7.705C13.9175 7.515 14.0775 7.375 14.2775 7.385C14.4675 7.395 14.6175 7.565 14.5975 7.755L14.1157 14.0189C14.0983 14.2441 14.3268 14.407 14.5341 14.3172L15.5775 13.865C15.7275 13.805 15.8375 13.675 15.8775 13.515L17.1275 8.855L17.9375 8.555L20.0475 7.825L27.3575 5.275C27.6075 5.205 27.8075 5.035 27.9375 4.815C28.0575 4.595 28.0875 4.335 28.0175 4.075L28.0075 4.065Z" fill="white" />
        </svg>

    )
};


const notchDownIcon = (
    <svg width="54" height="12" viewBox="0 0 54 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0.00990047 1.45509e-06L54 -9.04887e-07C48.4653 -6.6296e-07 43.1584 1.54479 39.2376 4.29342L29.1881 11.3633C27.9802 12.2122 26.0198 12.2122 24.8119 11.3633L14.7624 4.30038C10.8515 1.55175 5.54455 0.00695991 -5.24232e-07 0.00696015L0.00990047 1.45509e-06Z" fill="#606060" />
        <path d="M30.8934 4.7427C30.9272 4.77647 30.954 4.81657 30.9723 4.86072C30.9906 4.90486 31 4.95217 31 4.99996C31 5.04774 30.9906 5.09506 30.9723 5.1392C30.954 5.18334 30.9272 5.22345 30.8934 5.25722L27.2572 8.89336C27.2234 8.92716 27.1833 8.95398 27.1392 8.97228C27.0951 8.99058 27.0477 9 27 9C26.9522 9 26.9049 8.99058 26.8607 8.97228C26.8166 8.95398 26.7765 8.92716 26.7427 8.89336L23.1066 5.25722C23.0383 5.18899 23 5.09645 23 4.99996C23 4.90347 23.0383 4.81093 23.1066 4.7427C23.1748 4.67447 23.2673 4.63614 23.3638 4.63614C23.4603 4.63614 23.5528 4.67447 23.6211 4.7427L27 8.12204L30.3788 4.7427C30.4126 4.70889 30.4527 4.68207 30.4969 4.66377C30.541 4.64548 30.5883 4.63606 30.6361 4.63606C30.6839 4.63606 30.7312 4.64548 30.7753 4.66377C30.8195 4.68207 30.8596 4.70889 30.8934 4.7427ZM26.7427 5.25722C26.7765 5.29102 26.8166 5.31784 26.8607 5.33614C26.9049 5.35444 26.9522 5.36386 27 5.36386C27.0477 5.36386 27.0951 5.35444 27.1392 5.33614C27.1833 5.31784 27.2234 5.29102 27.2572 5.25722L30.8934 1.62107C30.9616 1.55284 30.9999 1.46031 30.9999 1.36382C30.9999 1.26733 30.9616 1.17479 30.8934 1.10656C30.8251 1.03833 30.7326 1 30.6361 1C30.5396 1 30.4471 1.03833 30.3788 1.10656L27 4.4859L23.6211 1.10656C23.5528 1.03833 23.4603 1 23.3638 1C23.2673 1 23.1748 1.03833 23.1066 1.10656C23.0383 1.17479 23 1.26733 23 1.36382C23 1.46031 23.0383 1.55284 23.1066 1.62107L26.7427 5.25722Z" fill="white" />
    </svg>
)

const NotchContainer = ({ hovered, cover, handleMouseEnter, handleMouseLeave }) => {
    const {
        profile: { property_details }
    } = useSelector((state) => state.auth);

    const { app_state, ui_state } = useSelector(
        (state) => state.app.current_state
    );
    const { property_id } = app_state;
    const sigmaReportsArr = getSigmaReports(property_details, property_id);
    const stateSigmaReportId = sessionStorage.getItem('sigma_report_id');
    const [tabValue, setTabValue] = useState(null);

    const handleAnalyticsReport = (id) => {
        const { property_id, property_name, workspace_controls, primary_stay_range } = app_state;
        const formatted_stay_date = moment().format('YYYY-MM-DD');
        window.analyze.track("sigma_analytics_report", {
            "selected_tile": ui_state.active_tiles.join(),
            property_id, property_name,
            stay_date: formatted_stay_date
        }, {}, {
            app_state: {
                workspace_controls,
            },
            ui_state: {
            }
        });

        updateKeyInMasterClass("sigma_report_id", id);
        localStorage.setItem("sigma_report_id", id)

        // lrv-1095 open report in new tab
        setTimeout(() => {
            const newUrl = window.location.origin + '/analytics-reports';
            window.open(newUrl, '_blank');
        }, 1000);

    }


    const handleTabChange = (event, newValue) => {
        // setTabValue(newValue);
        handleMouseLeave();
        localStorage.setItem('sigma_report_id', sigmaReportsArr[newValue].id);
        localStorage.setItem('tmp_report_id', sigmaReportsArr[newValue].id);
    };



    function CustomTabPanel(props) {
        const { children, value, index, ...other } = props;

        return (
            <div
                role="tabpanel"
                hidden={value !== index}
                id={`simple-tabpanel-${index}`}
                aria-labelledby={`simple-tab-${index}`}
                {...other}
            >
                {value === index && (
                    <Box sx={{ p: 3 }}>
                        <Typography>{children}</Typography>
                    </Box>
                )}
            </div>
        );
    }

    CustomTabPanel.propTypes = {
        children: PropTypes.node,
        index: PropTypes.number.isRequired,
        value: PropTypes.number.isRequired,
    };

    function a11yProps(index) {
        return {
            id: `simple-tab-${index}`,
            'aria-controls': `simple-tabpanel-${index}`,
        };
    }

    useEffect(() => {
        if (!sigmaReportsArr.length) return;

        const interval = setInterval(() => {
            const stateSigmaReportId = sessionStorage.getItem('sigma_report_id');
            if (stateSigmaReportId) {
                const index = sigmaReportsArr.findIndex(
                    report => String(report.id) === String(stateSigmaReportId)
                );
                if (index !== -1) {
                    setTabValue(index);
                }
                clearInterval(interval);
            }
        }, 1000); // check every 100ms

        return () => clearInterval(interval);
    }, [sigmaReportsArr]);

    const [loading, setLoading] = useState(true);
    useEffect(() => {
        setLoading(true);
        const timer = setTimeout(() => setLoading(false), 1000); // 1 second delay
        return () => clearTimeout(timer);
    }, [tabValue]);

    useEffect(() => {
        console.log("cover",cover)
    }, [cover]);

    const NotchDownIcon = () => {
        return (<>
            <div className='cover' style={{ opacity: cover ? 1 : 0 }}></div>
            <svg onMouseEnter={handleMouseEnter} width="54" height="14" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 54 14">
                <g>
                    <path
                        fill="#606060"
                        d="M0,0v2h0,0c5.54,0,10.85,1.55,14.76,4.3l10.05,7.06c1.21.85,3.17.85,4.38,0l10.05-7.07c3.92-2.75,9.23-4.29,14.76-4.29V0H0Z"
                    />
                    <path
                        fill="#fff"
                        d="M30.89,6.74s.06.07.08.12c.02.04.03.09.03.14s0,.1-.03.14c-.02.04-.05.08-.08.12l-3.64,3.64s-.07.06-.12.08c-.04.02-.09.03-.14.03s-.1,0-.14-.03c-.04-.02-.08-.05-.12-.08l-3.64-3.64c-.07-.07-.11-.16-.11-.26s.04-.19.11-.26c.07-.07.16-.11.26-.11s.19.04.26.11l3.38,3.38,3.38-3.38s.07-.06.12-.08c.04-.02.09-.03.14-.03s.1,0,.14.03c.04.02.08.05.12.08ZM26.74,7.26s.07.06.12.08c.04.02.09.03.14.03s.1,0,.14-.03.08-.05.12-.08l3.64-3.64c.07-.07.11-.16.11-.26s-.04-.19-.11-.26c-.07-.07-.16-.11-.26-.11s-.19.04-.26.11l-3.38,3.38-3.38-3.38c-.07-.07-.16-.11-.26-.11s-.19.04-.26.11c-.07.07-.11.16-.11.26s.04.19.11.26l3.64,3.64Z"
                    />
                </g>
            </svg>
        </>)
    }

    return (
        <Box
            className="notch-container"
            //onMouseLeave={handleMouseLeave}
        >
            <Box className={`report-title-container ${loading ? "loading" : ""}`}>
                <Box className="report-title">
                    {loading ? (
                        <><Skeleton variant="circular" width="20px" height="20px">
                        </Skeleton>
                            <Skeleton width="200px">
                                <Typography>.</Typography>
                            </Skeleton>
                        </>
                    ) : (
                        <>
                            {reportIcons[sessionStorage.getItem('sigma_report_id')] || null}
                            {
                                sessionStorage.getItem('sigma_report_id') === 'flight_ea'
                                ? 'Feeder Market Insights'
                                : sigmaReportsArr[sigmaReportsArr[tabValue] ? tabValue : 0]?.label || ''
                            }
                        </>
                    )}
                </Box>
            </Box>


            {sigmaReportsArr && sigmaReportsArr.length > 1 && sessionStorage.getItem('sigma_report_id') !== 'flight_ea' && (<><Box
                className={`arrow-down-icon ${hovered ? 'hide' : ''}`}
            //onMouseEnter={handleMouseEnter}
            >
                {/* {notchDownIcon} */}
                <NotchDownIcon />
            </Box>

                <Box className={`tabs-container ${hovered ? 'visible' : ''}`}>
                    <List
                        className='column-sort-container'
                        sx={{ width: '100%', maxWidth: 600, bgcolor: 'background.paper' }}
                        component="nav"
                        dense
                    >
                        <Box sx={{ borderColor: 'divider', width: '100%' }}>
                            <Tabs
                                className="mapping-tabs"
                                value={tabValue}
                                onChange={handleTabChange}
                                aria-label="Analytics Reports Tabs"
                            >
                                {sigmaReportsArr.map((report, index) => (
                                    <Tab
                                        onClick={() => handleAnalyticsReport(report?.id)}
                                        key={report.id || index}
                                        label={report.label}
                                        {...a11yProps(index)}
                                    />
                                ))}
                            </Tabs>
                        </Box>
                        <CustomTabPanel className="custom-tab-panel" value={tabValue} index={0}>
                            Tab 1
                        </CustomTabPanel>
                        <CustomTabPanel className="custom-tab-panel" value={tabValue} index={1}>
                            Tab 2
                        </CustomTabPanel>
                    </List>
                </Box></>
            )}
        </Box>
    );
};

export default NotchContainer;